var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TransitionBounceComponent',[(_vm.showTour && _vm.isCatalogTourCompleted)?_c('CatalogTourComponent'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }